import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=a7d033d4&scoped=true&"
import script from "./GoodsDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=a7d033d4&lang=scss&scoped=true&"
import style1 from "./GoodsDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d033d4",
  null
  
)

export default component.exports